import React from "react";
import GenerateExcerpt from "../generateExcerpt";
import GenerateTitle from "../generateTitle";
import {populateArticleData} from "../generateSummary";
import {truncateString} from "../../utils/stringUtils";

/**
 * Generate html for article summary (and replica summary??)
 *
 * @param params
 * @returns {*}
 * @constructor
 */
const GenerateCardCarousel = (params) => {
	params = Object.assign({
		entry: {},
		actions: {},
		displayParams: {}
	}, params);

	const entry = params.entry;
	const displayParams = Object.assign({},{
		maxSummaryCharacters: 155,
		useSummaryEllipsis: true,
	}, params.displayParams);

	const titleParams = {
		tag: 'h3',
		className: 'title',
		displayTitle: true,
	};

	// set article and issue properties for template
	const articleData = populateArticleData(entry, params.actions);
	// truncate summary if needed
	const summary = typeof entry.summary === 'string' && entry.summary !== '' ? truncateString(entry.summary, displayParams.maxSummaryCharacters, displayParams.useSummaryEllipsis) : '';

	// fallback to title for ALT tag if not available
	const imgAlt = typeof entry.squareImageAlt === 'string' && entry.squareImageAlt !== '' ? entry.squareImageAlt : entry.title + ", article thumbnail";

	// item link and title image wrap classes based on existence of thumbnail image
	const itemLinkClass = entry.squareImage ? 'item-link' : 'item-link no-thumbnail';
	const titleImageWrapClass = entry.squareImage ? 'title-issue-wrap' : 'title-issue-wrap no-thumbnail';

	/**
	 * Generate an a-tag element with different parts depending on whether an element exists or not
	 *
	 * Note: a title is always generated, so the a-tag will not be empty
	 */
	return (
		<>
			<div className={'indicator'} />
			<a href={articleData.url} className={itemLinkClass} data-articletitle={articleData.title} onClick={articleData.clickAction}>
				<div className={'description'}>
					<div className={titleImageWrapClass}>
						<GenerateTitle titleParams={titleParams}>{entry.title}</GenerateTitle>
					</div>
				</div>
				{
					entry.squareImage &&
					<div className={'thumbnail'}>
						<img alt={imgAlt} className={'thumbnail-image'} src={entry.squareImage} />
					</div>
				}
				{
					!entry.squareImage && summary &&
					<GenerateExcerpt className={'summary'} summary={summary} />
				}
			</a>
		</>
	);
};
export default GenerateCardCarousel;
